import { route as searchSuggestionsV2Route } from "@faire/web-api--source/api/v2/search/suggestions/post";

export const getSearchSuggestionsQueryKey = (query: string) => {
  return [searchSuggestionsV2Route, query];
};

export const EMPTY_SEARCH_SUGGESTION_QUERY_KEY =
  getSearchSuggestionsQueryKey("");
